import type { HelpGroup } from '@apis/help';
import type { IHelpSearchHit } from './searchGuides';

export const formatUpdated = (iso: string, language: string): string =>
  new Date(iso).toLocaleDateString(language === 'ja' ? 'ja-JP' : 'en-US', { year: 'numeric', month: 'short', day: 'numeric' });

export const groupLabelKey = (group: HelpGroup): string => `help.group.${group}`;

export const escapeRegExp = (text: string): string => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Points a guide body's screenshots at the API origin. Stored bodies carry
 * same-origin `/api/help/assets/…` paths; in dev the API runs on another port.
 * The session cookie is SameSite=Lax and localhost ports are same-site, so a
 * plain `<img>` request stays authenticated. Prod is same-origin (base '').
 */
export function rebaseHelpAssets(doc: Document, apiBase: string): void {
  if (apiBase === '') return;
  for (const img of doc.querySelectorAll('img[src^="/api/help/assets/"]')) img.setAttribute('src', `${apiBase}${img.getAttribute('src')}`);
}

/** A result lands on its match: the term (and, for a body hit, which occurrence)
 *  ride in the query string; the section stays in the hash. */
export function resultHref(hit: IHelpSearchHit, query: string): string {
  const params = new URLSearchParams({ find: query });
  if (hit.occurrence !== null) params.set('n', String(hit.occurrence));
  return `/help/${hit.slug}?${params.toString()}${hit.headingId ? `#${hit.headingId}` : ''}`;
}
